import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TertiaryCategories, TertiaryCategoriesAddPayload, TertiaryCategoriesEditPayload } from './tertiary-categories.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TertiaryCategoriesService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare.list;

    public listDTUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare.listDT;

    private findURL =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare.find;

    private storeURL =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare.store;

    private updateUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare.update;

    private deleteUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare
            .listPublic;

    private listBySubcategoryUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare
            .listBySubcategory;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare
            .public;

    private moveUpUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare
            .moveUp;

    private moveDownUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categoriiTertiare
            .moveDown;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: TertiaryCategoriesAddPayload) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: TertiaryCategoriesEditPayload) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http
            .get<{ errors: boolean; data: TertiaryCategories[]; status_code: number }>(
                this.listActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.title,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get tertiary categories:', error);
                    return throwError(error);
                })
            );
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    getListBySubcategory(id_subcategory: number) {
        return this.http
            .get<{ errors: boolean; data: TertiaryCategories[]; status_code: number }>(
                this.listBySubcategoryUrl + id_subcategory
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.title,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get tertiary categories:', error);
                    return throwError(error);
                })
            );
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    updatePosition(id: number, index: number) {
        if (index === 1) {
            // Position +1
            return this.http.put(this.moveUpUrl + id, {}, this.httpOptions);
        } else {
            // Position -1
            return this.http.put(this.moveDownUrl + id, {}, this.httpOptions);
        }
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
